import type { RouteRecordRaw } from 'vue-router'
import { legacyTenantRedirect } from './tenantScoped'

const userRoutes: RouteRecordRaw[] = [
  {
    path: 't/:tenantCode/profile',
    name: 'profile',
    component: () => import('@/views/user/Profile.vue')
  },
  {
    path: 'profile',
    component: () => import('@/views/user/Profile.vue'),
    beforeEnter: legacyTenantRedirect,
    meta: { legacyTenantRedirect: true }
  }
]

export default userRoutes
